import React from 'react';
import { FreeFormMenu } from '@/configs/menuItems';
import { getPathSegment } from '@/utils/pathUtils';
import SubMenu from '@/components/menu/sub-menu';

const FreeForm = () => {
  const pathSegment = getPathSegment();
  return <SubMenu active={pathSegment} items={FreeFormMenu} />;
};

export default FreeForm;
